import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Helmet } from "react-helmet";
import ServiceInclude from "../../component/ServiceInclude";


const CommunityCloud = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Community Cloud Consultant</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content=" "
                />
                <meta
                    name="keywords"
                    content=" "
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Community Cloud</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/Community-Cloud.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <p className="prose-lg wow fadeUp">Community Cloud is a cloud-based digital experience platform by Salesforce that helps businesses across various industries improve and manage their relationships with customers, partners, and employees. Communities built within this platform can be used for gathering customer feedback, providing customer support, lead qualification, training, and much more. It’s up to you to decide how to leverage its features both internally and externally within your organization.</p>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Benefits of Salesforce Community Cloud</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-1.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Community Creation</h3>
                                            <p className="wow fadeUp prose-lg">Salesforce Community Cloud acts as an interactive extension of your brand through its user-friendly environment. It allows you to customize the setup to align with your brand for a seamless online community experience. By integrating business data from any system, it brings together customers, employees, and partners to collaborate and complete their tasks efficiently.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-2.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Community Experience</h3>
                                            <p className="wow fadeUp prose-lg"> Automated recommendations based on individual needs, behaviors, and interests connect groups, content, and experts for deeper community engagement. You can access the community from anywhere using the Salesforce mobile app or any mobile browser, ensuring branded, device-responsive collaboration. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-3.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Rich, Self-Administration Experience for Clients</h3>
                                            <p className="wow fadeUp prose-lg"> Easy access to FAQs and articles empowers customers to find solutions independently, freeing up specialists to focus on more critical tasks. Community Cloud provides an overview of your employees, showing who's most active, and allows them to collaborate based on expertise and skills. Additional features include case escalation, e-commerce integration, and enhanced community engagement.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-4.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Speed up Deals Channels for Partners</h3>
                                            <p className="wow fadeUp prose-lg">Directly connecting partners, distributors, and affiliates helps drive sales by streamlining the sharing of records, leads, and contacts. It integrates with third-party systems, preventing channel conflicts. You can take immediate action on lead conversion and approval of funds directly within the feed. Additionally, it offers data sharing, dashboards, and reports to ensure alignment with your goals. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-5.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Drive Worker Efficiency and Commitment</h3>
                                            <p className="wow fadeUp prose-lg"> Teams can be organized by events, campaigns, or projects to access important information in an organized manner. By syncing records into a centralized location, your employees can easily access the right documents they need, all within a context that aligns with your core business processes. Through Chatter, collaboration is enhanced, fostering a dynamic work environment and encouraging the sharing of ideas.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Community Cloud Implementation</h2>
                                <p className="wow fadeUp prose-lg text-left">Salesforce Community Cloud Implementation makes it easy to create engaging experiences, attract customers, and empower partners. Community Cloud is a social platform from Salesforce designed to enhance communication and collaboration among an organization's employees, partners, and customers. It provides them with the records and data needed to perform their tasks efficiently. By streamlining key business operations and extending them across departments and offices, every member of the business environment can work more effectively, serve customers better, and close deals faster. The Salesforce Community Cloud is highly adaptable for any business need or use case. We can leverage our CRM data by directly connecting with our community or any third-party system. Overall, the web-based community platform enables our organization to create customized and branded networks that streamline business processes and foster seamless project collaboration.</p>
                            </div>
                        </div>

                        <div className="salesforc-services">
                            <div className='explore-heading text-left'>
                                <h2>What services does Codezix offer as a Salesforce Community Cloud Consultant? </h2>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Leveraging Chatter</h3>
                                        <p className="wow fadeUp prose-lg">Leverage Chatter to enhance communication within your organization. We design, implement, customize, and maintain Chatter in both Classic and Lightning Experience. Additionally, we assist you in migrating from Chatter Answers to Chatter Questions for improved collaboration.</p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/consulting.png')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Upgrade to Lightning Communities</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Unlock Lightning Experience for your organization in as little as a month. We enable fast and seamless migration of data, content, and custom Visualforce pages to the Lightning Community.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/analyse.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Migration to Salesforce Communities</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Transform passive data into valuable insights with Salesforce Community, which is tightly integrated with other Salesforce Clouds. Migrate from Jive, Lithium, or any other platform to the Lightning Community with zero data loss, no UX/UI disruption, and thorough QA testing.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/integration.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Reconciliation With Outsider Frameworks</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Enhance digital interactions in your community by establishing a closed-loop connection with other systems such as CMS, LMS, support tools, search consoles, and analytics. Our experts utilize APIs and custom-built connectors to provide fast, flexible, and secure integrations.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/CRM.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Customization</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Receive customizations that not only address your current needs but also help you achieve your future strategic and business goals. Our technologists have the expertise and skills to add new components and functionality, maximizing the potential of your Salesforce environment—while ensuring alignment with your brand guidelines.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/training.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Versatile Experience</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Enhance the experience for your customers, partners, and employees who are more likely to engage with you from their mobile devices than from a desktop. We analyze usage patterns for each segment to provide mobile-friendly solutions for your community.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/launch.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Plan</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Think beyond aesthetics. Our UI/UX experts analyze your use cases to identify key trends and recommend valuable opportunities for improvement. Our goal is to maximize adoption and make design decisions that are most suitable for your community.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Plan66.webp" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Execution</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Harness the true power of Salesforce. We dive deep into your processes, use cases, and systems to implement a solution in stages. We also assist you in getting onboard, streamlining operations, and delivering the results your business requires.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Execution7.webp" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Methodology</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Align your organizational goals with customer needs through a strategic Lightning Community. Our experts take the time to understand your business objectives, analyze your target customers, conduct a gap analysis, and build a business case for utilizing Salesforce Community by evaluating the return on investment.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Methodology.webp" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>What benefits does Codezix offer as a Salesforce Community Cloud Partner?</h2>
                                <p className="prose-lg wow fadeUp text-left">We at Codezix are expert Salesforce Community Cloud Partners who not only help businesses grow but also enhance their productivity.</p>
                            </div>

                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Flexible Management Models</li>
                                            <li className="wow fadeUp prose-lg"> 24x7 Support Across all Timezones</li>
                                            <li className="wow fadeUp prose-lg"> Competitive Prices and Ontime Delivery</li>
                                            <li className="wow fadeUp prose-lg"> State-of-the-art IT Infrastructure</li>
                                            <li className="wow fadeUp prose-lg"> Strone Technology Competence</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg"> Seamless Communication</li>
                                            <li className="wow fadeUp prose-lg"> Years of Expertise</li>
                                            <li className="wow fadeUp prose-lg"> 1800+ Customers</li>
                                            <li className="wow fadeUp prose-lg">Salesforce Partner </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </>
    )
}

export default CommunityCloud;